import React from 'react';
import {Platform, ScrollView, View} from 'react-native';

import Button from '/component/base/Button';
import Icon from '/component/base/Icon';
import BasePopover from '/component/base/Popover';
import TouchableOpacity from '/component/base/TouchableOpacity';
import Gutter from '/component/layout/Gutter';
import {withSafeArea} from '/provider/SafeAreaProvider';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {getPopoverContent, getStyles} from '../ClientReportPopover.util';
import {Loading as ClientInfoLoading} from '../component/ClientInfo';
import {Loading as ClientVolumeLoading} from '../component/Volume';

import {ALL_CONTENT} from './Loading.constant';
import {styles} from './Loading.style';

interface LoadingProps {
  tt: (key: string, fallback: string) => string;
  ts: (key: string, fallback: string) => string;
  safeAreaInsets: {
    top?: number;
    bottom?: number;
    left?: number;
    right?: number;
  };
  popoverClose: () => void;
  contentName: string;
  contentProps: Record<string, any>;
}

export const Loading: React.FC<LoadingProps> = ({
  tt,
  ts,
  safeAreaInsets = {},
  contentName = '',
  popoverClose = () => {},
  contentProps = {},
}) => {
  const isWeb = Platform.OS === 'web';
  const {popoverStyle, footerButtonStyle} = getStyles(safeAreaInsets);
  const PopoverContent = getPopoverContent(contentName, ALL_CONTENT);
  return (
    <BasePopover style={popoverStyle}>
      <View style={styles.closeButton}>
        <TouchableOpacity
          accessible={true}
          accessibilityRole="button"
          accessibilityLabel={ts('close', 'Close')}
          onPress={popoverClose}>
          <Icon name="close" />
        </TouchableOpacity>
      </View>
      <Gutter>
        <ClientInfoLoading />
      </Gutter>
      <ScrollView>
        <PopoverContent {...contentProps} />
        <Gutter>
          <ClientVolumeLoading contentName={contentName} />
        </Gutter>
      </ScrollView>
      <View style={footerButtonStyle}>
        <Gutter>
          <Button
            disabled
            accessibilityLabel="View profile"
            style={
              isWeb
                ? {
                    base: {
                      minHeight: 28,
                      paddingHorizontal: 14,
                      paddingVertical: 6,
                    },
                    text: {fontSize: 13},
                  }
                : undefined
            }>
            {tt('footer.profileButton.label', 'View Profile')}
          </Button>
        </Gutter>
      </View>
    </BasePopover>
  );
};

export default withHOC(
  withSafeArea,
  withTranslation('reportCard.client'),
)(Loading);
